var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemAddCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.523 2 12 6.477 2 12 2m0 4.757a1 1 0 0 0-1 1V11H7.757a1 1 0 1 0 0 2.002h3.241v3.243a1 1 0 0 0 1.001.999 1 1 0 0 0 1-1v-3.242h3.244a1 1 0 0 0 0-2.001H13V7.757a1 1 0 0 0-1.001-1",
  clipRule: "evenodd"
})));
export default SvgGemAddCircleFilled;